import Vue from 'vue';

const state = {
	defaultDiscussionPoints: [],
	defaultDiscussionPoints_loading: false
};

const getters = {
	defaultDiscussionPoints: state => {
		return state.defaultDiscussionPoints;
	},
	managerDiscussionPoints: state => {
		return state.defaultDiscussionPoints.filter(x => x.item.type === 3);
	}
};

const actions = {
	get({ commit, rootState }) {
		console.log('Retrieving Default Discussion Points...');
		commit('GET_PENDING');
		return Vue.axios
			.get(`/api/${rootState.tenantId}/defaultDiscussionPoints`)
			.then(response => {
				commit('GET_SUCCESS', response.data);
			})
			.catch(error => {
				commit('GET_FAILURE', error);
			});
	},
	add({ commit, dispatch, rootState }, item) {
		console.log('Adding New Discussion Point...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/api/${rootState.tenantId}/defaultDiscussionPoints`, item)
				.then(resp => {
					commit('ADD_SUCCESS', item);
					dispatch('get');
					resolve(resp);
				})
				.catch(err => {
					console.log('Error saving Discussion Point');
					console.log(err);
					reject(err);
				});
		});
	},
	edit({ commit, dispatch, rootState }, defaultDiscussionPoint) {
		console.log('Updating Default Discussion Point...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/api/${rootState.tenantId}/defaultDiscussionPoints/${defaultDiscussionPoint.id}`, defaultDiscussionPoint)
				.then(resp => {
					commit('EDIT_SUCCESS', defaultDiscussionPoint);
					dispatch('get');
					resolve(defaultDiscussionPoint);
				})
				.catch(err => {
					console.log('Error updating Default Discussion Point');
					console.log(err);
					reject(err);
				});
		});
	},
	delete({ commit, dispatch, rootState }, defaultDiscussionPoint) {
		console.log('Deleting Default Discussion Point...');
		return new Promise((resolve, reject) => {
			Vue.axios
				.delete(`/api/${rootState.tenantId}/defaultDiscussionPoints/${defaultDiscussionPoint.id}`)
				.then(resp => {
					commit('DELETE_SUCCESS', defaultDiscussionPoint);
					dispatch('get');
					resolve(true);
				})
				.catch(err => {
					console.log('Error deleting Default Discussion Point');
					console.log(err);
					reject(err);
				});
		});
	}
};

const mutations = {
	GET_PENDING(state) {
		state.defaultDiscussionPoints_loading = true;
	},
	GET_SUCCESS(state, data) {
		state.defaultDiscussionPoints_loading = false;
		state.defaultDiscussionPoints = data;
	},
	GET_FAILURE(state, error) {
		state.defaultDiscussionPoints_loading = false;
		console.log(error);
	},
	ADD_SUCCESS(state, data) {
		state.defaultDiscussionPoints.push(data);
	},
	EDIT_SUCCESS(state, data) {
		let found = state.defaultDiscussionPoints.find(pr => pr.id === data.id);
		if (found != null) {
			found = data;
		}
	},
	DELETE_SUCCESS(state, data) {
		const index = state.defaultDiscussionPoints.indexOf(data);
		state.defaultDiscussionPoints.splice(index, 1);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
